// ** Icon imports
import HomeIcon from "mdi-material-ui/Home";
import CalendarIcon from "mdi-material-ui/Calendar";
import ClockIcon from "mdi-material-ui/Clock";
import TaskIcon from "mdi-material-ui/CheckboxMarkedCircle";
import MessageIcon from "mdi-material-ui/Message";
import AccountGroupIcon from "mdi-material-ui/AccountGroup";
import ArchiveIcon from "mdi-material-ui/Archive";
import CogIcon from "mdi-material-ui/Cog";
import HelpCircleIcon from "mdi-material-ui/HelpCircle";
import LogoutIcon from "mdi-material-ui/Logout";
import DashboardIcon from "mdi-material-ui/ViewDashboard";
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import LockPersonOutlinedIcon from '@mui/icons-material/LockPersonOutlined';
import PlayLessonIcon from '@mui/icons-material/PlayLesson';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import SubjectIcon from '@mui/icons-material/Subject';
import CategoryIcon from '@mui/icons-material/Category';
import ChatIcon from "mdi-material-ui/Chat";
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';
import SouthAmericaIcon from '@mui/icons-material/SouthAmerica';
import PrivacyTipOutlinedIcon from '@mui/icons-material/PrivacyTipOutlined';
import HttpsOutlinedIcon from '@mui/icons-material/HttpsOutlined';

const navigation = (t) => {
  return [
    {
      sectionTitle: t("MENU")
    },
    {
      title: t("Dashboard"),
      icon: DashboardIcon,
      path: "/dashboard",
    },
    {
      title: t("User Management"),
      icon: AccountGroupIcon,
      path: "/user-management",
    },
    {
      sectionTitle: t("ROLES & PERMISSIONS"),
    },
    {
      title: t("Roles"),
      icon: GroupOutlinedIcon,
      path: "/roles",
    },
    {
      title: t("Permissions"),
      icon: LockPersonOutlinedIcon,
      path: "/permissions",
    },
    {
      title: t("Sub Admin"),
      icon: AccountGroupIcon,
      path: "/sub-admin",
    },
    {
      sectionTitle: t("Category and Region"),
    },
    {
      title: t("Category"),
      icon: CategoryIcon,
      path: "/category",
    },
    {
      title: t("Region"),
      icon: SouthAmericaIcon,
      path: "/region",
    },
    {
      sectionTitle: t("Lesson Management"),
    },
    {
      title: t("Course"),
      icon: SubjectIcon,
      path: "/courses",
    },
    {
      sectionTitle: t("Cultural Management"),
    },
    {
      title: t("Cultural"),
      icon: LibraryMusicIcon,
      path: "/cultural-module",
    },
    {
      sectionTitle: t("Terms & Privacy"),
    },
    {
      title: t("Terms & Conditions"),
      icon: HttpsOutlinedIcon,
      path: "/terms-and-conditions",
    },
    {
      title: t("Privacy Policy"),
      icon: PrivacyTipOutlinedIcon,
      path: "/privacy-policy",
    },


    // {
    //   sectionTitle: t("GENERAL")
    // },
    // {
    //   title: t("Settings"),
    //   icon: CogIcon,
    //   path: "/setting"
    // },
    // {
    //   title: t("Help & Support"),
    //   icon: HelpCircleIcon,
    //   path: "/help-support"
    // },

  ]
}

export default navigation
